import { SSkeletonDisplayText } from 'components/shared/s-polaris';

export const UsageUpsellSkeleton: React.FC = () => (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="md:col-span-2">
            <SSkeletonDisplayText height="236px" maxWidth="100%" />
        </div>
        <SSkeletonDisplayText height="236px" maxWidth="100%" />
    </div>
);
